module.exports = __webpack_public_path__ + "static/media/maheshwari.1ffc362c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/maheshwari.jpg
// module id = 1285
// module chunks = 0